import { Component, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppMenuComponent} from '../app.menu.component';
import { SidebarModule } from 'primeng/sidebar';
import { LayoutService } from '../../shared/services/layout.service';




@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  standalone: true,
  imports: [AppMenuComponent, SidebarModule, CommonModule]
})
export class SidemenuComponent {

  constructor(public layoutService: LayoutService, public el: ElementRef){}

}